export interface IAppendSkillPagingParamsProps {
  params: URLSearchParams;
  page?: number;
  limit?: number;
}

export interface IAppendSkillSearchParamProps {
  params: URLSearchParams;
  search?: string;
}

// NOTE: NSAI-3309/NSAI-3311 — the paging and search query-string rules the skills
// routes already follow, stated once so the sharing and catalog clients cannot
// build a subtly different cache key for the same request.
export const appendSkillPagingParams = ({
  params,
  page,
  limit,
}: IAppendSkillPagingParamsProps): URLSearchParams => {
  if (page !== undefined) {
    params.set("page", String(page));
  }

  if (limit !== undefined) {
    params.set("limit", String(limit));
  }

  return params;
};

// NOTE: A trimmed-empty needle is omitted rather than sent as `search=`. The
// server reads both as "no filter", but omitting it keeps the query string — and
// therefore the React Query cache key — identical to an untouched search box.
export const appendSkillSearchParam = ({
  params,
  search,
}: IAppendSkillSearchParamProps): URLSearchParams => {
  const trimmed = search?.trim();

  if (trimmed) {
    params.set("search", trimmed);
  }

  return params;
};
